export const MAP_CONTROL_GROUP_CLASS =
  'flex overflow-hidden rounded-lg border bg-background shadow-sm';

export const MAP_CONTROL_SEGMENT_CLASS =
  'flex h-6 items-center px-2 text-2xs font-medium transition-colors lg:h-7 lg:px-2.5 lg:text-xs';

export const MAP_CONTROL_ACTIVE_CLASS = 'bg-primary text-primary-foreground';
